import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import SEO from '../../../components/common/SEO';
import ReactWOW from 'react-wow';
import FeatureCards from "../../../components/features/FeatureCards"
import Video from '../../../components/features/Video'
import Info from '../../../components/features/Info'

export const query = graphql`
  query CompetenciesQuery {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
    const [toggler, setToggler] = useState(false)
    const lightboxProps = {
        toggler: toggler,
        setToggler: setToggler,
        sources: ["https://www.youtube.com/watch?v=tCU89zYKCyU&feature=youtu.be"],
    }

    const bannerProps = {
        title: 'Competency Assessments',
        subtitle: `Incompetence in your workforce can be costly. Mistakes by unskilled workers can lead to accidents, injuries, property damage, spills, defects, delays, inefficiencies, customer and revenue losses, regulatory trouble, and even lawsuits. What is at the other end of that spectrum where safety, quality and efficiency rule? Competence. And how to you ensure Competency? Assessments! `,
        featureName: 'Competency',
        rightButtonText: 'Why Compentency Assessment Software?',
        rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
        mockupImg: '/features/competencies/header.png'
    }

    const questionProps = {
        // question: 'Has your bulletin board become a piece of antique abstract art?',
        answer: `The problem with incompetence is its inability to recognize itself. If you have the stomach, do a quick search for videos of people trying hover boards or unicycles for the first time. They usually start with some poor bloke thinking the new skill is simple enough and can be mastered in short order. This is usually followed by an epic fail. Your workplace is no different. Your new hand will no doubt watch an old pro effortlessly perform a task, misjudge the complexity of the task, and fail to grasp the subtle nuances exhibited by the veteran.`,
        questionTwo: `No doubt your organization has a system of training and overseeing new hires before they are exposed to operational risks, but this process likely has:`,
        answerBulletList: [
            'Loose or poorly defined standards',
            'Inconsistent conveyance of expectations and guidance',
            'An unclear path of progression',
            'Non-existent feedback and documentation',
        ],
        imageSrc: '/features/competencies/cartoon.jpg',
        imgAlt: 'Cartoon of man lacking the compentency to tye down a sail.',
        isImageLeft: false
    }

    const videoProps = {
        videoSrc: 'https://youtube.com/VOSUNYrSGvo',
        videoImage: '/features/competencies/youtubethumb.png',
        videoStatement: (<strong>Competency Assessments</strong>),
    }

    const seo = {
        title: 'Workhub | Free Competency Assessment Tool Evaluate',
        description: 'Our Competency Assessment Software lets you assess & review your employees performance, safety, proficiencies, behaviors & abilities so that you can reduce workplace accidents, boost productivity and improve efficiency.',
        image: '/features/competencies/social-card.jpg',
        // pathname,
        // article
    }

    const featureIndex = [
        {
            title: "Assess",
            para: "Ensure that your workers are safely and successfully performing procedures and daily tasks.",
        },
        {
            title: "Prerequisites",
            para: "Link policies, online training & certifications that are necessary to complete prior to a Competency Assessment.",
        },
        {
            title: "Checklist",
            para: "Build a checklist of behaviors, concepts & tasks that must be performed and observed during an operation, for a worker to be considered competent.",
        },
        {
            title: "Qualified Assessors",
            para: "Create a list of people that are qualified to test other members of your workforce.",
        },
        {
            title: "Commenting",
            para: "Assessors can add comments to detail worker performance or show where improvements need to be made. ",
        },
        {
            title: "History and Compliance",
            para: "Track and report on worker competency and follow up with those missing an assessment. ",
        },
        {
            title: "Performance Criteria",
            para: "Designate workers as Requires Supervision, Independently Competent or Instructor/Assessor.",
        },

    ]

    // const infoProps = {
    //     imageLeftToRight: false,
    //     infoList: [
    //         {
    //             mockupImage: '/features/competencies/prereqs.png',
    //             infoTitle: 'Set Prerequisites and Performance Criteria',
    //             infoSubtitle: `Invariably, some tasks or procedures performed at your workplace are difficult, unsafe, or otherwise prone to screwups. ${(<p>hello</p>)} Workhub’s Procedures component allows you create guides for how to complete tasks as safely as possible, and Competencies adds a layer of certainty by allowing trusted assessors to gauge workers’ ability to execute. Competencies use two elements to ascertain that: prerequisites and performance criteria. Prerequisites are items from other compliance components that workers need to have completed to be assessed. They can include courses, certificates, policies, and procedures. Each assigned worker needs to have the prescribed items under their belt before assessment. Performance criteria are actions, behaviors, or even awareness of concepts that are relevant to successfully executing the tasks included in the competency. Ideally, each criterion can be verified using the five senses. “Can safely back a 53’ trailer into loading dock” is a much better criterion than “Makes customers happy”.`,
    //             infoBullets: [
    //             ],
    //         },{
    //             mockupImage: '/features/competencies/qualified-assessors.png',
    //             infoTitle: 'Build a list of qualified assessors',
    //             infoSubtitle: `Every competency needs qualified assessors before workers can be assessed - there’s no sense in having someone unqualified assess someone! Qualified assessors in your organization should be easy to spot. They’re the folks who have been safely and correctly completing the tasks up to now, and you can indicate that by adding a prequalification for those people for your chosen competency.  Be sure to add a reason for their prequalification, like “journeyman ticket” or “ten years’ experience”.`,
    //             infoBullets: [
    //             ],
    //         },{
    //             mockupImage: '/features/competencies/request-assessments.png',
    //             infoTitle: 'Assessees request assessments',
    //             infoSubtitle: `We’re not entirely sure that Assessee is a real word, but it’s the term we’ve given to the newbies that need to prove their competency to the aforementioned assessors in your organization. Workers can see the performance criteria and prerequisites for their assigned competencies, so they know what to complete, what to study, and what to practice (with supervision) in preparation for their assessment. Workers can choose from a list of available assessors and request assessment, or admins can assign assessors to assessees for assessment. Workhub sends the assessor a notification of the request so they can work with the worker to arrange a time and place to complete it.`,
    //             infoBullets: [
    //             ],
    //         },{
    //             mockupImage: '/features/competencies/competency-assessment.png',
    //             infoTitle: 'The competency assessment',
    //             infoSubtitle: `When the assessor and assessee get together for the assessment, it’s a good idea for the assessor to have a smartphone or tablet open to Workhub’s assessment page to record the results step-by-step. If a device isn't accessible, assessors can also print out a blank assessment sheet to use instead, and can fill the digital version in after. Assessors can observe the worker completing the steps of the task and enter their assessment status for each criterion. If they complete each step well, an assessee can be marked as Competent! If they aren’t able to independently complete even one of the criteria, however, they’ll be recorded as Requires Supervision. If the assessee is a total whiz and passes with flying colours, the assessor can also deem them as competent as an Instructor/Assessor! This means they can be set up to assess others as well. Each Worker can be assessed multiple times, so encouraging folks to polish up their skills and proficiencies to attain that Competent assessment.`,
    //             infoBullets: [
    //             ],
    //         },
    //     ]
    // }

    return (
        <Layout {...lightboxProps}>
            <SEO {...seo} {...data.site} />
            <Banner {...bannerProps} {...lightboxProps} />

            <section style={{ marginTop: '60px' }}>
                <div className="behaviour-container">
                    <div className="behaviour-grid">

                        {/* First Paragraph */}

                        <p style={{ padding: '1rem' }}>The problem with incompetence is its inability to recognize itself. If you have the stomach, do a quick search for videos of people trying hover boards or unicycles for the first time. They usually start with some poor bloke thinking the new skill is simple enough and can be mastered in short order. This is usually followed by an epic fail. Your workplace is no different. Your new hand will no doubt watch an old pro effortlessly perform a task, misjudge the complexity of the task, and fail to grasp the subtle nuances exhibited by the veteran.</p>

                        {/* Checklist */}

                        <div className="grid-item media-margin">
                            <p style={{ marginBottom: '2.5rem' }}>No doubt your organization has a system of training and overseeing new hires before they are exposed to operational risks, but this process likely has:</p>
                            <ul className="checklist">
                                <li>Loose or poorly defined standards</li>
                                <li>Inconsistent conveyance of expectations and guidance</li>
                                <li>An unclear path of progression</li>
                                <li>Non-existent feedback and documentation</li>
                            </ul>
                        </div>

                        {/* Cartoon */}

                        <div className="grid-item grid-item-flex">
                            <aside>
                                <ReactWOW animation="fadeInLeft" delay="0.3s">
                                    <img src={questionProps.imageSrc} alt="Competencies Cartoon" /></ReactWOW>
                            </aside>
                        </div>

                    </div>
                </div>
            </section>

            {/* Video Section */}

{/* 
            <section className="erp_action_area">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">

                            <div className="video_info video_training" style={{ background: `url('${videoProps.videoImage}') no-repeat`, backgroundSize: 'cover' }}>
                                <div className="ovarlay_color"></div>
                                <div className="popup-youtube video_icon" onClick={() => this.props.setToggler(videoProps.toggler)} href={videoProps.videoSrc} style={{ display: 'block!important' }}>
                                    <img src="/app-icons/layout-icons/youtube-round-color.svg" alt="Youtube Icon" />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="erp_content">
                                <h2>What are <strong>Competencies</strong> and why do <strong>Assessments</strong>?</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

<Video {...videoProps} {...lightboxProps} />

            {/* Info Section */}
{/* <Info {...infoProps} /> */}

            <section style={{ marginTop: '100px' }}>
                <div className="behaviour-container" style={{ borderBottom: '1px solid #ececf6' }}>
                    <div className="behaviour-grid" style={{ marginBottom: '20px' }}>
                        <h2 style={{ marginBottom: '1.5rem', marginLeft: '1.5rem' }}>Set prerequisites and assessment criteria</h2>

                        <div className="grid-item ">
                            <p>
                                Invariably, some tasks or procedures performed at your workplace are difficult, unsafe, or otherwise prone to screwups. Workhub’s Procedures component allows you to create guides for how to complete tasks as safely as possible, and Competencies adds a layer of certainty by allowing trusted assessors to gauge workers’ ability to execute. Competencies use two elements to ascertain that: prerequisites and performance criteria.
                            </p>
                            <p>
                                Prerequisites are items from other compliance components that workers need to have completed to be assessed. They can include courses, certificates, policies, and procedures. Each assigned worker needs to have the prescribed items under their belt before assessment.
                            </p>
                            <p>
                                Performance criteria are actions, behaviors, or even awareness of concepts that are relevant to successfully executing the tasks included in the competency. Ideally, each criterion can be verified using the five senses. “Can safely back a 53’ trailer into loading dock” is a much better criterion than “Makes customers happy”.
                            </p>
                        </div>
                        <div className="grid-item grid-item-flex">
                            <aside>
                                <ReactWOW animation="fadeInRight" delay="0.3s">
                                    <img src='/features/competencies/prereqs.png' style={{ marginBottom: '1.5rem' }} alt="Prerequisite Screenshot" />
                                </ReactWOW>
                            </aside>
                        </div>

                    </div>
                </div>
            </section>


            <section style={{ borderBottom: '1px solid #ececf6', margin: 'auto', padding: '2.5rem 1.5rem' }}>
                <div className="behaviour-container">
                    <h2 style={{ marginBottom: '1.5rem', marginLeft: '1.5rem' }}>Build a list of qualified assessors</h2>

                    <div className="behaviour-grid flex-row-reverse">
                        <div className="grid-item">
                            <p>
                                Every competency needs qualified assessors before workers can be assessed - there’s no sense in having someone unqualified assess someone! Qualified assessors in your organization should be easy to spot. They’re the folks who have been safely and correctly completing the tasks up to now, and you can indicate that by adding a prequalification for those people for your chosen competency.  Be sure to add a reason for their prequalification, like “journeyman ticket” or “ten years’ experience”.
                            </p>
                        </div>
                        <div className="grid-item grid-item-flex">
                            <aside>
                                <ReactWOW animation="fadeInLeft" delay="0.3s">
                                    <img src='/features/competencies/qualified-assessors.png' alt="Driver Assessment Screenshot" />
                                </ReactWOW>
                            </aside>
                        </div>
                    </div>    
                </div>            
            </section>

            <section style={{ borderBottom: '1px solid #ececf6', margin: 'auto', padding: '2.5rem 1.5rem' }}>
                <div className="behaviour-container">
                    <h2 style={{ marginBottom: '1.5rem', marginLeft: '1.5rem' }}>Assessees request assessments</h2>

                    <div className="behaviour-grid">
                        <div className="grid-item">
                            <p>
                                We’re not entirely sure that Assessee is a real word, but it’s the term we’ve given to the newbies that need to prove their competency to the aforementioned assessors in your organization. Workers can see the performance criteria and prerequisites for their assigned competencies, so they know what to complete, what to study, and what to practice (with supervision) in preparation for their assessment. Workers can choose from a list of available assessors and request assessment, or admins can assign assessors to assessees for assessment. Workhub sends the assessor a notification of the request so they can work with the worker to arrange a time and place to complete it.
                            </p>
                        </div>
                        <div className="grid-item grid-item-flex">
                            <aside>
                                <ReactWOW animation="fadeInLeft" delay="0.3s">
                                    <img src='/features/competencies/request-assessments.png' alt="Driver Assessment Screenshot" />
                                </ReactWOW>
                            </aside>
                        </div>
                    </div>    
                </div>            
            </section>

            <section style={{ marginBottom: '80px' }}>
                <div className="behaviour-container">
                    <h2 style={{ marginBottom: '1.5rem', marginTop: '2.5rem', marginLeft: '1rem' }}>The competency assessment</h2>

                    <div className="behaviour-grid flex-row-reverse">
                        <div className="grid-item">
                            <p>
                                When the assessor and assessee get together for the assessment, it’s a good idea for the assessor to have a smartphone or tablet open to Workhub’s assessment page to record the results step-by-step. If a device isn’t accessible, assessors can also print out a blank assessment sheet to use instead, and can fill the digital version in after. Assessors can observe the worker completing the steps of the task and enter their assessment status for each criterion.
                            </p>
                            <p>
                                If they complete each step well, an assessee can be marked as Competent! If they aren’t able to independently complete even one of the criteria, however, they’ll be recorded as Requires Supervision. If the assessee is a total whiz and passes with flying colours, the assessor can also deem them as competent as an Instructor/Assessor! This means they can be set up to assess others as well.
                            </p>
                            <p>
                                Each Worker can be assessed multiple times, so encouraging folks to polish up their skills and proficiencies to attain that Competent assessment. 
                            </p>
                        </div>
                        <div className="grid-item grid-item-flex">
                            <aside>
                                <ReactWOW animation="fadeInLeft" delay="0.3s">
                                    <img src='/features/competencies/competency-assessment.png' alt="Driver Assessment Screenshot" />
                                </ReactWOW>
                            </aside>
                        </div>
                    </div>
                </div>
            </section>

            {/* FEATURE OVERVIEW */}

            <section className="feature-overview-container">
                <h2>Overview</h2>

                <div className="feature-overview-grid" style={{ marginBottom: '60px' }}>
                    {featureIndex.map(item => (
                        <FeatureCards title={item.title} para={item.para} />
                    ))}
                </div>
            </section>


        </Layout>
    )
}